import { Injectable } from '@angular/core';
import { XAPIDataGenerator } from 'libs-frontend-xapi/dist/js/xapidatagenerator.js';
import { XAPIHelperService } from './xAPI-helper.service';
import { ImgBookHelperService } from './img-book-helper.service';
import { HttpClient } from '@angular/common/http';
import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';
import { Subject } from 'rxjs';
import { environment } from 'environments/environment';
import DesktopConfig from 'modules/desktop/services/config';
import { DesktopEBookVMService } from 'modules/desktop/services/desktop-ebook-vm.service'
import { StudentBookService } from './student-book.service';

@Injectable()
export class NotesDataService {
    noteData: any;
    callWaiting = false;
    timer: any;
    xAPIPostDelay = 5000;
    hasDataChanged: boolean;
    studentBookCode: string;
    spaceId: string;
     // actions possible on a note
     dataActions = {
        DELETED: "deleted",
        SAVED: "saved",
    }
    //variable used for getting all notes
    allNotes:any;
    orphanNotes:any = [];
    pages:any = [];
    offlineData:any = {};
    isRemoteCall:boolean = true;
    params:any = {};
    flattenedJSON;
    errorResponse:any = {};
    offlineOnlineNotifier = new Subject<any>();
    offlineOnlineObservable$ = this.offlineOnlineNotifier.asObservable();

    // Do your operations
    constructor(
        private xAPIHelperService: XAPIHelperService,
        private apiGatewayHelperService: ApiGatewayHelperService,
        private http: HttpClient,
        private imgBookHelperService: ImgBookHelperService,
        private desktopEBookVMService: DesktopEBookVMService,
        private studentBookService: StudentBookService,
    ) { }

    /* Using note data and creating custom statement to be posted to the xAPI*/
    createCustomStatement(action?) {
        let userData;
        //sending xAPI to delete current note
        let localNotesData = this.getNotesDataFromLocalStorage();
        if (!localNotesData && this.dataActions.DELETED) {
            userData = this.noteData.user_data;
        }
        else {//saving cases
            userData = localNotesData.user_data;
        }

        let options = {
            'user_data': userData
        }

        return {
            id: "" + userData.documentid,
            statement: XAPIDataGenerator.generateCustomStatement("" + userData.documentid, 'annotated', options),
            userData: userData
        };
    }

    /**
     * Function to make postStatments call
     * @param customStatement : response received from xAPI generateCustomStatement call
     */
    async postStatmentToXAPI({ id, statement, userData }) {

        // let xapiLOAnalytics = this.xAPIHelperService.getXAPIAnalyticsObject();
        this.noteData.isNewlyCreated = false;
        localStorage.removeItem('notesDataInLocalStorage');
        this.callWaiting = false;

        if (this.desktopEBookVMService.getActiveVM()) {
            this.desktopEBookVMService.addNewDirtyRecord(DesktopEBookVMService.USER_DATA_TYPE.NOTES, { id, statement, userData });
        } else {
            this.xAPIHelperService.postStatmentToXAPI(id, statement);
        }

    }

    //  data = {
    //   "action": "saved",
    //   "data": {
    //     "data": {
    //       "color": "#40D992",
    //       "pageNo": "104",
    //       "serial": 120,
    //       "data": "12",
    //       "mode": "saved",
    //       "viewOnMobile": false,
    //       "id": "Rasx6nqPyJlJAquh",
    //       "hasDataChanged": true,
    //       "svg": "ColorPentagon_green.svg"
    //     },
    //     "selector": "Rasx6nqPyJlJAquh"
    //   }
    //   }

    /* Saving note data */
    saveNoteData(data, studentBookCode, spaceId) {
        let noteData = data.data.data;
        let noteAction = data.action;
        this.studentBookCode = studentBookCode;
        this.spaceId = spaceId;
        let uniqueID = noteData.id;

        let xAPIAction = {
            "created": "create",
            "edited": "update",
            "deleted": "delete"
        }[noteAction];



        this.noteData = {
            "identifier": uniqueID,
            "isNewlyCreated": (noteAction === "created"),
            "user_data": {
                "documentid": uniqueID,
                "folderid": this.studentBookCode + '/note/p_' + noteData.pageNo +'/',
                "action": xAPIAction,
                "type": 'note',
                "payload": JSON.stringify({
                    "meta":{
                        "pageLabel": noteData.pageNo
                        /* "pageSerial": noteData.serial */
                    },
                    "data": {
                        "color": noteData.color,
                        "text": noteData.data,
                        "pinPosition": noteData.pinPosition
                    }
                })
            }
        }


        let localNotesData = this.getNotesDataFromLocalStorage();
        if (noteAction === 'created' || noteAction === 'edited') {
            if (this.callWaiting
                && localNotesData
                && (localNotesData.identifier !== this.noteData.identifier)
            ) {
                this.timer && clearTimeout(this.timer);
                this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.SAVED));
            }
            localStorage.setItem('notesDataInLocalStorage', JSON.stringify(this.noteData));
            this.postNoteData();
        } 
        else {
            //Handles delete cases
            if (localNotesData && this.callWaiting) {
                // scenario when deleted note is not same as the note present in local storage
                if (localNotesData.identifier !== this.noteData.identifier) {
                    // save the note data present in local storage
                    this.timer && clearTimeout(this.timer);
                    this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.SAVED));
                    // delete the note data for which this delete operation has been performed
                    this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.DELETED));
                }
                else if(localNotesData.isNewlyCreated == false){
                    this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.DELETED));
                }
                else{
                    // This handles the case when a note is added,edited and deleted within timer,no xAPI call
                    this.callWaiting = false;
                    clearTimeout(this.timer);
                    localStorage.removeItem('notesDataInLocalStorage');
                }
            }
            else if (this.noteData) {
                //deleting posted data
                this.postStatmentToXAPI( this.createCustomStatement(this.dataActions.DELETED));
            }

        }
    }

    /* delaying xAPI call for delayed seconds */
    postNoteData() {
        if (!this.callWaiting) {
            this.callWaiting = true;
            this.timer = setTimeout(() => {
                this.postStatmentToXAPI(this.createCustomStatement(this.dataActions.SAVED));
            }, this.xAPIPostDelay)
        }
    }

    /* Fetching notes data from local storage */
    getNotesDataFromLocalStorage() {
        return JSON.parse(localStorage.getItem('notesDataInLocalStorage'));
    }

    checkPendingDataInLocalStorage(){
        let data = this.getNotesDataFromLocalStorage();
        return data;
    }

    postPendingNotesToXAPI(){
        let hasLocalData = this.getNotesDataFromLocalStorage();
        /* triggering xAPI to post immediately*/
        this.timer && clearTimeout(this.timer)
        hasLocalData && this.postStatmentToXAPI(this.createCustomStatement());
    }

    /**
     * function to update and populate the service variable with the notes data as fetched from server.
     * this is similar to the getNotes function but without error handling and retry.
     * the data provided here is fetched at the time on getbook data call in resolver.
     * this is done to populate the note's pin information and show the note hotspots on the page.
     * any change made here should be made in getNotes function as well.
     * this function was not called from getNotes or they are not combined as getNotes still makes multiple calls in case of curser found and can be called multiple times,
     * whereas this function paints all the notes fetched at once and should only be called once per book load.
     * @param notesData - notes data as fetched from server
     *                  = {
     *                      entities : [noteObjects as recieved from server(xapi format) ]
    *                     }
     * @param studentBookCode - current book code.
     * @returns array of notes divided per page.
     *  [
     *      {   pagelabel,
     *          page serial,
     *          notes : [modified notes object]
     *      }
     * ]
     */
    updateNotesDataFetchedFromServer(notesData, studentBookCode) {

        this.allNotes = this.allNotes || {};
        this.isRemoteCall = false;

        //creating desired data notes object in the memory
        notesData.entities.forEach(note => {

            let data = JSON.parse(note.data);

            // fetch unsaved data for this note by documentId 
            // and update the data received from server
            let unsavedNote;
            if (this.desktopEBookVMService.getActiveVM()) {
                unsavedNote = this.xAPIHelperService.getUnsavedDataByDocumentId(note.documentId.substring(3));
            } else {
                unsavedNote = this.xAPIHelperService.getUnsavedDataByDocumentId(note.documentid);
            }

            if (unsavedNote) {
                data = JSON.parse(unsavedNote.payload);

                // return if the note was deleted and 
                // this change has not yet been saved to the server
                if (unsavedNote.action == "delete") {
                    return;
                }
            }

            if (this.desktopEBookVMService.getActiveVM()) {
                this.setNoteData(data, { documentid: note.documentId.substring(3), created: note.timestamp });
            } else {
                this.setNoteData(data, { documentid: note.documentid, created: note.created });
            }
        });

        // fetch unsaved notes which have not been sent to the server even once
        let unsavedNotes = this.xAPIHelperService.getUnsavedDataByFolderId(studentBookCode + "/note/");
        // merge unsaved notes data into notes from server
        unsavedNotes.forEach(note => {
            let data = JSON.parse(note.payload);

            // return if the note was deleted
            if (note.action == "delete") {
                return;
            }

            this.setNoteData(data, { documentid: note.documentid, created: note.created });
        })

        if (this.allNotes && Object.keys(this.allNotes).length) {
            Object.keys(this.allNotes).forEach((pageSerial) => {
                let notes = this.allNotes[pageSerial].sort((a, b) => {
                    return a.created - b.created;
                });
                this.allNotes[pageSerial] = notes;
            });
            this.pages = this.createPagesFromNotes(this.allNotes);
        }

        return this.pages;

    }

    public async getNotes(studentBookCode, options) {
        try{

            // return the notes, if they are found in memory (No fresh Remote Call)
            if(this.allNotes && !this.isRemoteCall) {
                return this.pages;
            }

            // Remote Call - getting call to foc server and resolved by its router there
            this.isRemoteCall = true;
            options = options || {};
            options.retryAttempt = options.retryAttempt || 0;


            let notesdata: any = {};
            let baseURL = this.apiGatewayHelperService.getApiGatewayPrefixUrl();
            if (environment.isDesktopApp) {
                baseURL = DesktopConfig.app.api.baseUrl + baseURL;
            }

            if (this.desktopEBookVMService.getActiveVM()) {

                let somData = this.desktopEBookVMService.getLocalData();
                notesdata = {
                    entities: somData.notesData,
                    cursor: ""
                }

            } else {

                if(environment.isDesktopApp && !this.studentBookService.isEbookInView){
                    return;
                }

                notesdata = await this.http.post(baseURL + 'fetchNotes', { "cursor": options.cursor, 'studentBookCode': studentBookCode}).toPromise();
            }

            if(notesdata.status && notesdata.status == "error"){
                console.log("Remote Call Error:");
                if(options.maxRetryAttempt) {
                    return this.retryHandler(studentBookCode , options);
                }

                this.isRemoteCall = false;
                this.errorResponse = {"status":"error", "type" : "NOTES_DATA_API_ERROR"};
                this.allNotes = undefined;
                return this.errorResponse; 
                
            }

            this.allNotes = this.allNotes || {};

            //creating desired data notes object in the memory
            notesdata.entities.forEach(note => {
                
                if(note && note.dirty && note.dirty.userAction == 'delete') return;
                let data = JSON.parse(note.data);

                // fetch unsaved data for this note by documentId 
                // and update the data received from server
                let unsavedNote;
                if(this.desktopEBookVMService.getActiveVM()) {
                    unsavedNote = this.xAPIHelperService.getUnsavedDataByDocumentId(note.documentId.substring(3));
                } else {
                    unsavedNote = this.xAPIHelperService.getUnsavedDataByDocumentId(note.documentid);
                }
                if (unsavedNote) {
                    data = JSON.parse(unsavedNote.payload);

                    // return if the note was deleted and 
                    // this change has not yet been saved to the server
                    if (unsavedNote.action == "delete") {
                        return;
                    }
                }

                if(this.desktopEBookVMService.getActiveVM()) {
                    this.setNoteData(data, {documentid: note.documentId.substring(3), created: note.timestamp});
                } else {
                    this.setNoteData(data, {documentid: note.documentid, created: note.created});
                }
            });

            // Break condition of recursion if the cursor returned from server is null / empty string 
            if(notesdata.cursor == "") {
                this.isRemoteCall = false;
                // fetch unsaved notes which have not been sent to the server even once
                let unsavedNotes = this.xAPIHelperService.getUnsavedDataByFolderId(studentBookCode+"/note/");
                // merge unsaved notes data into notes from server
                unsavedNotes.forEach(note => {
                    let data = JSON.parse(note.payload);

                    // return if the note was deleted
                    if (note.action == "delete") {
                        return;
                    }

                    this.setNoteData(data, {documentid: note.documentid, created: note.created});
                })

                if(this.allNotes && Object.keys(this.allNotes).length) {
					Object.keys(this.allNotes).forEach((pageSerial)=> {
	                    let notes = this.allNotes[pageSerial].sort((a,b) => {
	                        return a.created-b.created;
	                    });
	                    this.allNotes[pageSerial] = notes;
                	});
                    this.pages = this.createPagesFromNotes(this.allNotes);
                }

                return this.pages;

            } else {
                options.cursor = notesdata.cursor;
                return this.getNotes(studentBookCode, options);
            }
        } catch(error) {
            
            console.log("Error occured while fetching notes");
            console.log(error);
            if(options.maxRetryAttempt) {
                return this.retryHandler(studentBookCode , options);
            }
            this.isRemoteCall = false;
            this.errorResponse = {"status":"error", "type" : "EXCEPTION_THROWN"};
            this.allNotes = undefined;
            return this.errorResponse; 
        }
    }

    private setNoteData(data, options){
        if(data.meta) {
            var temp = {
                "data":{
                    "color": data.data.color,
                    "pageNo": data.meta.pageLabel,
                    "serial": this.imgBookHelperService.getPageSerialByPageLabel(data.meta.pageLabel),
                    "data": data.data.text,
                    "mode": "saved",
                    "viewOnMobile": false,
                    "id": options.documentid,  
                    "svg": "ColorCircle_green.svg",
                    "pinPosition": data.data.pinPosition  
                },
                "selector": options.documentid,
                "created" : options.created
            };

            
            // serial for some pages are undefined (because those pages are not mentioned in TOC, but notes are created for those pages earlier)
            if(temp.data.serial) {
                this.allNotes[temp.data.serial] = this.allNotes[temp.data.serial] || [];
                this.allNotes[temp.data.serial].push(temp);
            } else {
                this.orphanNotes.push(temp);
            }
        }

    }

    //reset required note data service variables when book is toggled  
    resetAllNotes(){
        this.allNotes = undefined;
        this.orphanNotes = [];
        this.pages = [];
        this.isRemoteCall = true;
        this.errorResponse = {};
    }

    //perforn retry handling of request and return failure on third attempt
    async retryHandler(studentBookCode , options) {
        if(options.retryAttempt == options.maxRetryAttempt){
            this.isRemoteCall = false;
            this.errorResponse = {"status":"error", "type":"MAX_RETRY_ATTEMPT_REACHED"};
            this.allNotes = undefined;
            return this.errorResponse;
        } else {
            await this.sleep(1000);
            options.retryAttempt += 1;
            return this.getNotes(studentBookCode , options);
            
        }
    }

    getOfflineObservable() {
        return this.offlineOnlineObservable$;
    }

    offlineWorkflow(studentBookCode, options) {
        
        this.offlineData.t1 = this.offlineData.t2 || 2;
        this.offlineData.t2  = this.offlineData.t || 3;
        this.offlineData.t = this.offlineData.t1 + this.offlineData.t2;

        console.log("🚀 ~ file: notes-data.service.ts ~ line 348 ~ NotesDataService ~ offlineWorkflow ~ this.offlineData.t", this.offlineData.t);        

        this.offlineData.workflow =  setTimeout(async ()=> {
            if(navigator.onLine) {
                this.offlineData.notes = await this.getNotes(studentBookCode, options);
                this.offlineOnlineNotifier.next({"data" : this.offlineData.notes});
            } else {
                this.offlineWorkflow(studentBookCode, options);
            }
        }, this.offlineData.t * 1000);      

    }

    resetOfflineWorkflow() {
        this.offlineData = {};
    }

    //takes notes in input and generates student book page object 
    createPagesFromNotes(notes) {
        this.pages = [];
        Object.keys(notes).forEach((pageSerial)=> {
            this.pages.push({
                "label": notes[pageSerial][0].data.pageNo,
                "serial":pageSerial, //for accessing correct page number
                "isOpen": false,
                "notes":notes[pageSerial]
            });
        });

        //  orphan notes handling -> currently, orphan notes are added to last page of the book
        if(this.orphanNotes && this.orphanNotes.length) {
            let lastPage = this.imgBookHelperService.lastPage;
            
            let found = this.pages.findIndex((page)=> {
                return page.serial == lastPage.serial;
            });

            if(found == -1) {
                this.pages.push({
                    "label": lastPage.label,
                    "serial": lastPage.serial, //for accessing correct page number
                    "isOpen": false,
                    "notes": []
                });
            }

            lastPage = this.pages[this.pages.length-1];

            this.orphanNotes.forEach((note)=> {
                note.data.serial = lastPage.serial;
                note.data.pageNo = lastPage.label;
                note.data.orphan = true;
            });

            lastPage.notes = lastPage.notes.concat(this.orphanNotes);
        }        
        
        return this.pages;
    }    

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}